<img src="icons/arrow_bottom.svg" alt="arrow_back" class="h-14 mt-14 mb-2">